import React, {Component} from "react";

import * as componentTypes from "../../../../constants/componentTypes";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as formulaActions from "../../../../actions/formulaActions";
import * as getterHelper from "../../../../helpers/getterHelper";
import * as handlers from "../../../../constants/handlers";
import * as iconHelper from "../../../../helpers/iconHelper";
import * as importDataActions from "../../../../actions/importDataActions";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as navigationActions from "../../../../actions/navigationActions";
import * as ticketingActions from "../../../../actions/ticketingActions";
import * as ticketTypes from "../../../../constants/ticketTypes";
import * as translationHelper from "../../../../helpers/translationHelper";
import * as windowService from "../../../../services/windowService";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";
import Modal from "../../../global/generic/Modal";
import {ReactSVG} from "react-svg";
import SearchInputSelectBox from "../../../global/generic/SearchInputSelectBox";

import {connect} from "react-redux";
import imgClose from "../../../../resources/img/svgicons/cancel2.svg";
import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import imgLoad from "../../../../resources/img/svgicons/load-formula.svg";
import {translate} from "react-i18nify";

const remote = window.require === undefined ? null : window.require("@electron/remote");

class TicketingModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: this.props.params.type ?? ticketTypes.TICKET_TYPE_FORMULA_REQUEST.id,
            request: "",
            attachments: [],
            operator: this.props.loggedUser,
            fandeck: this.props.params.fandeck ?? null,
            color: this.props.params.color ?? null,
            product: this.props.params.product ?? null,
            base: this.props.params.base ?? null,
            department: null,
            productGroupId: null,
            selectedColorName: "",
            subject: "",
            localData: false
        };
    }

    setType = (type) => {
        if (type === ticketTypes.TICKET_TYPE_SERVICE_TICKET.id && this.props.serviceDepartmentList.length === 0) {
            this.props.dispatchGetServiceDepartments();
        }

        this.setState({
            ...this.state,
            type: type,
            request: "",
            attachments: [],
            fandeck: this.props.params.fandeck ?? null,
            color: this.props.params.color ?? null,
            product: this.props.params.product ?? null,
            base: this.props.params.base ?? null,
            department: null,
            productGroupId: null,
            selectedColorName: "",
            subject: "",
            localData: false
        });
    };

    componentDidMount() {
        this.props.dispatchGetFandeck(null, null);
        this.props.dispatchGetProduct(null, null);

        this.setState({localData: this.props.formula?.local});
    }

    onStringChange = (event) => {
        this.setState({
            ...this.state,
            [event.target.id]: event.target.value
        });
    };

    setFandeck = (fandeck) => {
        this.setState({
            ...this.state,
            fandeck: fandeck,
            color: null
        });
        if (fandeck) {
            this.props.dispatchGetColor(fandeck.id, null);
        } else {
            this.props.dispatchGetFandeck(null, null);
        }
    };

    setColor = (color) => {
        this.setState({
            ...this.state,
            color: color
        });
    };

    setProduct = (product) => {
        this.setState({
            ...this.state,
            product: product,
            base: null
        });
        if (product) {
            this.props.dispatchGetBase(product.id, null);
        } else {
            this.props.dispatchGetProduct(null, null);
        }
    };

    setBase = (base) => {
        this.setState({
            ...this.state,
            base: base
        });
    };

    setServiceDepartment = (serviceDepartment) => {
        this.setState({department: serviceDepartment});
    };

    changeAttachmentPath = (filename) => {
        this.setState({
            attachments: this.state.attachments.concat([filename])
        });
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseCreateTicketModalAction();
    };

    handleLoadFormulaButton = () => {
        if (this.props.params.ticket) {
            let ticket = this.props.ticketList.find((ticket) => ticket.ticketId === this.props.params.ticket.ticketId);

            if (ticket.formulaCombinationId !== null) {
                this.props.dispatchLoadTicketFormula(this.props.tabId, ticket.formulaCombinationId);
            } else {
                this.props.dispatchAddAndLoadTicketFormula(
                    this.props.tabId,
                    this.props.params.ticket.jsonAttributes.formula_xml,
                    this.props.params.ticket.jsonAttributes.formula,
                    this.props.params.ticket.id
                );
            }
        }
    };

    callFunctionWithTimeout = (func) => {
        let self = this;
        let tempTimeoutId = setTimeout(function () {
            if (tempTimeoutId === self.globalSerchTimeoutId) {
                func();
            }
        }, 700);

        this.globalSerchTimeoutId = tempTimeoutId;
    };

    getFandeckList = (fandeckName) => {
        this.callFunctionWithTimeout(() => {
            this.props.dispatchGetFandeck(this.state.color?.id, fandeckName);
        });
    };

    getColorList = (colorName) => {
        this.callFunctionWithTimeout(() => {
            this.props.dispatchGetColor(this.state.fandeck?.id, colorName);
        });
    };

    getProductList = (productName) => {
        this.callFunctionWithTimeout(() => {
            this.props.dispatchGetProduct(null, productName);
        });
    };

    getBaseList = (baseName) => {
        this.callFunctionWithTimeout(() => {
            this.props.dispatchGetBase(null, baseName);
        });
    };

    handleUploadAttachmentClick = () => {
        windowService.openSelectFileDialog("", this.changeAttachmentPath, [
            "pdf",
            "jpg",
            "jpeg",
            "png",
            "zip",
            "txt",
            "dat"
        ]);
    };

    getRequiredSymbol = () => {
        return <span className="color-red">{this.props.params.ticket ? null : " *"}</span>;
    };

    isRequestOrClaim = () => {
        return (
            this.state.type === ticketTypes.TICKET_TYPE_FORMULA_REQUEST.id ||
            this.state.type === ticketTypes.TICKET_TYPE_FORMULA_CLAIM.id
        );
    };

    isServiceTicket = () => {
        return this.state.type === ticketTypes.TICKET_TYPE_SERVICE_TICKET.id;
    };

    renderRow = (
        label,
        value,
        className = "row-full",
        editable = false,
        inputId = "",
        mandatory = false,
        inputElement = null,
        disabled = false
    ) => {
        const getInput = () => {
            if (inputElement) {
                return inputElement;
            }

            return (
                <Input
                    className="primary-input"
                    type="text"
                    id={inputId}
                    value={value}
                    disabled={disabled}
                    onChange={this.onStringChange}
                />
            );
        };
        return (
            <div className={"ticket-modal-row " + className}>
                <div className="row-label">
                    {label}:{mandatory ? this.getRequiredSymbol() : ""}
                </div>
                <div className="row-value">{editable ? getInput() : value}</div>
            </div>
        );
    };

    openCustomerModal = () => {
        this.props.dispatchOpenCustomersModal(this.props.tabId);
    };

    getCustomer = () => {
        if (this.isRequestOrClaim()) {
            return this.renderRow(
                translate("general.customer"),
                this.props.params.ticket?.customer?.name ?? this.props.customer?.name ?? (
                    <span className="text-muted">{translate("spectroTab.notSelected")}</span>
                ),
                "row-full",
                !this.props.params.ticket,
                null,
                false,
                <Input
                    className="primary-input"
                    type="text"
                    readOnly
                    value={this.props.customer?.name ?? ""}
                    labelAfter={
                        <label className="cursor-pointer">
                            <span className="padding-10">...</span>
                        </label>
                    }
                    labelAfterAction={this.openCustomerModal}
                />
            );
        }

        return null;
    };

    getFandeck = () => {
        if (this.isRequestOrClaim()) {
            return this.renderRow(
                translate("general.fandeck"),
                this.props.params.ticket?.fandeck?.displayName ?? this.state.fandeck?.displayName ?? "",
                "row-full",
                !this.props.params.ticket && !this.props.params.fandeck,
                null,
                true,
                <SearchInputSelectBox
                    optionsList={this.props.fandeckList}
                    selectedValue={this.state.fandeck}
                    property={"displayName"}
                    loading={false}
                    valueSelected={this.setFandeck}
                    onChange={this.getFandeckList}
                />
            );
        }

        return null;
    };

    getColor = () => {
        const getValue = (color) => {
            if (!color) {
                return null;
            }

            if (color.rgb && color.displayName) {
                return (
                    <div className="flex">
                        <div className="color-square" style={{backgroundColor: color.rgb}} />
                        {color.displayName}
                    </div>
                );
            }

            if (color.displayName) {
                return <div className="flex">{color.displayName}</div>;
            }

            return null;
        };
        if (this.isRequestOrClaim()) {
            return this.renderRow(
                translate("general.color"),
                getValue(this.props.params.ticket?.color) ??
                    getValue(this.state.color) ??
                    (this.state.fandeck
                        ? ""
                        : translate("general.selectXFirst", {item: translate("general.fandeck")}) + "..."),
                "row-full",
                !this.props.params.ticket && !this.props.params.color,
                null,
                true,
                this.state.fandeck ? (
                    <SearchInputSelectBox
                        optionsList={this.props.colorList}
                        selectedValue={this.state.color}
                        property={"displayName"}
                        loading={false}
                        valueSelected={this.setColor}
                        onChange={this.getColorList}
                    />
                ) : null,
                !this.state.fandeck
            );
        }

        return null;
    };

    getProduct = () => {
        if (this.isRequestOrClaim()) {
            return this.renderRow(
                translate("general.product"),
                this.props.params.ticket?.product?.displayName ?? this.state.product?.displayName ?? "",
                "row-full margin-top-20",
                !this.props.params.ticket && !this.props.params.product,
                null,
                true,
                <SearchInputSelectBox
                    optionsList={this.props.productList?.[0]?.items ?? []}
                    selectedValue={this.state.product}
                    property={"displayName"}
                    loading={false}
                    valueSelected={this.setProduct}
                    onChange={this.getProductList}
                />
            );
        }

        return null;
    };

    getBase = () => {
        if (this.isRequestOrClaim()) {
            return this.renderRow(
                translate("general.base"),
                this.props.params.ticket?.base?.displayName ??
                    this.state.base?.displayName ??
                    (this.state.product || this.props.params.ticket?.product ? (
                        <span className="text-muted">{translate("spectroTab.notSelected")}</span>
                    ) : (
                        translate("general.selectXFirst", {item: translate("general.product")}) + "..."
                    )),
                "row-full",
                !this.props.params.ticket && !this.props.params.base,
                null,
                false,
                this.state.product ? (
                    <SearchInputSelectBox
                        optionsList={this.props.baseList}
                        selectedValue={this.state.base}
                        property={"displayName"}
                        loading={false}
                        valueSelected={this.setBase}
                        onChange={this.getBaseList}
                    />
                ) : null,
                !this.state.product
            );
        }

        return null;
    };

    getServiceDepartmentNameByTicket = () => {
        if (!this.props.params.ticket) {
            return "";
        }

        let departmentId = this.props.params.ticket?.jsonAttributes?.department_id;

        if (departmentId === undefined) {
            return <span className="text-muted">{translate("spectroTab.notSelected")}</span>;
        }

        let department = getterHelper.getObjectById(this.props.serviceDepartmentList, departmentId);

        if (department === null) {
            return <span className="text-muted">{translate("general.unknown")}</span>;
        }

        return department.name;
    };

    getServiceDepartment = () => {
        if (!this.isServiceTicket()) {
            return null;
        }

        return this.renderRow(
            "Department",
            this.getServiceDepartmentNameByTicket(),
            "row-full",
            !this.props.params.ticket,
            null,
            false,
            <SearchInputSelectBox
                optionsList={this.props.serviceDepartmentList}
                selectedValue={this.state.department}
                property="name"
                loading={false}
                valueSelected={this.setServiceDepartment}
                onChange={() => {}}
            />,
            !this.props.params.ticket
        );
    };

    getAttachments = () => {
        if (this.props.params.ticket || windowService.isBrowser()) {
            return null;
        }

        return (
            <div className={"ticket-modal-row row-full"}>
                <div className="row-label">{translate("general.attachments")}:</div>
                <div className="row-value">
                    <Input
                        className="primary-input"
                        type="text"
                        readOnly
                        value={this.state.attachments}
                        labelAfter={
                            <label className="cursor-pointer" onClick={this.handleUploadAttachmentClick}>
                                <span className="padding-10">...</span>
                            </label>
                        }
                    />
                </div>
            </div>
        );
    };

    handleAttachmentDownload = async (name, id) => {
        let path;

        if (remote) {
            path = await remote.dialog
                .showSaveDialog({
                    title: "Save attachment as",
                    defaultPath: name,
                    filters: [
                        // {
                        //     name: "db",
                        //     extensions: ["db"]
                        // }
                    ]
                })
                .then((result) => {
                    if (!result.canceled) {
                        return result.filePath;
                    }

                    return null;
                });
        }

        if (!path) {
            return;
        }

        this.props.dispatchSaveFileToPath(id, path);
    };

    renderAttachmentsToDownload = (attachments, addMargin = false) => {
        if (!remote || !attachments?.length) {
            return null;
        }

        let className = "ticket-modal-row row-full";

        if (addMargin) {
            className += " margin-top-20";
        }

        return (
            <div className={className}>
                <div className="row-label">{translate("general.attachments")}:</div>
                <div className="row-value">
                    {attachments.map((attachment, i) => (
                        <React.Fragment key={attachment.id}>
                            {i > 0 && <span className="text-muted">&nbsp;/&#160;</span>}
                            <a
                                key={attachment.id}
                                onClick={() => this.handleAttachmentDownload(attachment.name, attachment.id)}
                            >
                                {attachment.name}
                            </a>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        );
    };

    getStatusColor = (status) => {
        switch (status) {
            case ticketTypes.TICKET_STATUS_SENDING.id:
            case ticketTypes.TICKET_STATUS_SENT.id:
                return "red";
            case ticketTypes.TICKET_STATUS_WAITING_FOR_ANSWER.id:
                return "orange";
            case ticketTypes.TICKET_STATUS_ANSWERED.id:
                return "green";
            default:
                return null;
        }
    };

    getStatusText = (status) => {
        switch (status) {
            case ticketTypes.TICKET_STATUS_SENDING.id:
            case ticketTypes.TICKET_STATUS_SENT.id:
                return translate("ticketing.sending");
            case ticketTypes.TICKET_STATUS_WAITING_FOR_ANSWER.id:
                return translate("ticketing.waitingForAnswer");
            case ticketTypes.TICKET_STATUS_ANSWERED.id:
                return translate("ticketing.answered");
            default:
                return null;
        }
    };

    renderTypeBox = (type) => {
        let className =
            "fill-flex-space primary-border padding-10 flex flex-align-center-vertical text-bold cursor-pointer";
        if (this.state.type === type) {
            className += " color-primary fill-primary";
        }

        if (this.state.type !== type) {
            className += " disabled-border fill-black";
        }

        return (
            <div
                id={`ticket-type-${type}`}
                key={type}
                className={className}
                onClick={() => {
                    this.setType(type);
                }}
            >
                <div className="fit-image size20x20 margin-right-5">
                    <ReactSVG src={iconHelper.getTicketTypeIcon(type)} />
                </div>
                {translationHelper.getTicketTypeTranslation(type)}
                <div className="margin-left-auto">
                    <input
                        type="radio"
                        className="click-through"
                        id={type.toString()}
                        name={`ticket-type-select`}
                        value={type}
                        checked={this.state.type === type}
                        readOnly
                    />
                </div>
            </div>
        );
    };

    getTypeOptions = () => {
        const types = [
            ticketTypes.TICKET_TYPE_FORMULA_REQUEST.id,
            ticketTypes.TICKET_TYPE_MESSAGE_TICKET.id,
            ticketTypes.TICKET_TYPE_SERVICE_TICKET.id
        ];

        return <div className="flex flex-gap-5px">{types.map((type) => this.renderTypeBox(type))}</div>;
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.state.type !== ticketTypes.TICKET_TYPE_FORMULA_CLAIM.id &&
                    !this.props.params.ticket &&
                    this.renderRow(translate("general.type"), this.getTypeOptions())}
                {this.state.type === ticketTypes.TICKET_TYPE_FORMULA_CLAIM.id &&
                    !this.props.params.ticket &&
                    this.renderRow(
                        translate("general.type"),

                        <div className="flex flex-gap-5px">
                            {this.renderTypeBox(ticketTypes.TICKET_TYPE_FORMULA_CLAIM.id)}
                            <div className="fill-flex-space" />
                            <div className="fill-flex-space" />
                        </div>
                    )}
                {this.props.params.ticket?.status &&
                    this.renderRow(
                        translate("general.status"),
                        <div className="flex flex-align-center-vertical">
                            <span
                                className="dot margin-right-5"
                                style={{
                                    backgroundColor: this.getStatusColor(this.props.params.ticket.status)
                                }}
                            />
                            <span>{this.getStatusText(this.props.params.ticket.status)}</span>
                        </div>,
                        "left-half"
                    )}
                {this.props.params.ticket?.id &&
                    this.renderRow(
                        translate("general.created"),
                        this.props.params.ticket?.requestDate
                            ? formatHelper.formatDateTimeUtc(this.props.params.ticket.requestDate)
                            : formatHelper.formatDateTime(new Date()),
                        "right-half"
                    )}
                {this.renderRow(
                    translate("general.operator"),
                    this.props.params.ticket?.operator ?? this.state.operator ?? translate("general.notSpecified"),
                    (this.props.params.ticket ? "left-half " : "row-full ") +
                        (this.props.params.ticket ? "" : "margin-top-20"),
                    !this.props.params.ticket,
                    "operator"
                )}
                {this.props.params.ticket?.answerDate &&
                    this.renderRow(
                        translate("ticketing.answered"),
                        formatHelper.formatDateTimeUtc(this.props.params.ticket?.answerDate),
                        "right-half"
                    )}
                {this.getCustomer()}
                {this.getProduct()}
                {this.getFandeck()}
                {this.getColor()}
                {this.getBase()}
                {this.getServiceDepartment()}
                {this.state.type === ticketTypes.TICKET_TYPE_SERVICE_TICKET.id &&
                    this.renderRow(
                        translate("helper.subject"),
                        this.props.params.ticket?.subject ?? this.state.subject,
                        "row-full margin-top-20",
                        !this.props.params.ticket,
                        "subject",
                        this.isSubjectMandatory()
                    )}
                {(this.props.params.ticket?.request?.trim() || !this.props.params.ticket) &&
                    this.renderRow(
                        translate("ticketing.comment"),
                        this.props.params.ticket?.request ?? this.state.request,
                        this.state.type === ticketTypes.TICKET_TYPE_SERVICE_TICKET.id
                            ? "row-full"
                            : "row-full margin-top-20",
                        !this.props.params.ticket,
                        "request",
                        this.isRequestMandatory(),
                        <textarea
                            className="primary-input primary-border slim-scroll"
                            id={"request"}
                            value={this.props.params.ticket?.request ?? this.state.request}
                            onChange={this.onStringChange}
                        />
                    )}
                {this.getAttachments()}
                {this.renderAttachmentsToDownload(
                    this.props.params.ticket?.attachmentsRequest ?? [],
                    this.props.params.ticket && !this.props.params.ticket.request?.trim()
                )}
                {this.props.params.ticket?.status === ticketTypes.TICKET_STATUS_ANSWERED.id && (
                    <div className="divider margin-top-10 margin-bottom-10" />
                )}
                {this.props.params.ticket?.answer &&
                    this.renderRow(translate("ticketing.answer"), this.props.params.ticket?.answer, "left-half")}
                {this.props.params.ticket?.answer &&
                    this.props.params.ticket?.resolvedBy &&
                    this.renderRow(
                        translate("ticketing.resolvedBy"),
                        this.props.params.ticket?.resolvedBy,
                        "right-half"
                    )}
                {this.props.params.ticket?.jsonAttributes?.formula_xml &&
                    this.renderRow(
                        translate("general.formula"),
                        <span className="color-success bold flex-child">
                            {translate("ticketing.formulaAttached", {
                                loadFormula: `"${translate("general.loadFormula")}"`
                            })}
                        </span>,
                        !this.props.params.ticket?.answer ? "left-half" : "row-full"
                    )}
                {this.props.params.ticket?.jsonAttributes?.unrealizable &&
                    this.renderRow(
                        translate("general.formula"),
                        <span className="color-warning bold">{translate("ticketing.formulaUnrealizable")}</span>,
                        !this.props.params.ticket?.answer ? "left-half" : "row-full"
                    )}
                {!this.props.params.ticket?.answer &&
                    this.props.params.ticket?.resolvedBy &&
                    this.renderRow(
                        translate("ticketing.resolvedBy"),
                        this.props.params.ticket?.resolvedBy,
                        "right-half"
                    )}

                {this.renderAttachmentsToDownload(this.props.params.ticket?.attachmentsAnswer ?? [])}
            </React.Fragment>,
            "flex-wrap slim-scroll "
        );
    };

    isRequestMandatory = () => {
        return (
            this.state.type === ticketTypes.TICKET_TYPE_MESSAGE_TICKET.id ||
            this.state.type === ticketTypes.TICKET_TYPE_SERVICE_TICKET.id
        );
    };

    isSubjectMandatory = () => {
        return this.state.type === ticketTypes.TICKET_TYPE_SERVICE_TICKET.id;
    };

    isSendDisabled = () => {
        if (this.props.sendingRequest) {
            return true;
        }

        if (this.isRequestMandatory() && this.state.request.trim() === "") {
            return true;
        }

        if (this.isSubjectMandatory() && this.state.subject.trim() === "") {
            return true;
        }

        if (this.isRequestOrClaim()) {
            return !this.state.fandeck || !this.state.color || !this.state.product;
        }

        return false;
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {!this.props.params.ticket ? (
                    <Button
                        label={translate("ticketing.create")}
                        svgBefore={imgConfirm}
                        disabled={this.isSendDisabled()}
                        tooltipText={
                            !this.state.request || !this.state.subject
                                ? translate("clientServerSettings.fillRequiredFields")
                                : null
                        }
                        onClick={() => {
                            this.props.dispatchCreateTicketAction(
                                {
                                    ...this.state,
                                    customer: this.props.customer,
                                    type: this.state.type
                                },
                                this.props.version
                            );
                        }}
                    />
                ) : null}
                {this.props.params.ticket?.status === ticketTypes.TICKET_STATUS_ANSWERED.id &&
                [ticketTypes.TICKET_TYPE_MESSAGE_TICKET.id, ticketTypes.TICKET_TYPE_SERVICE_TICKET.id].includes(
                    this.state.type
                ) ? (
                    <Button
                        label={translate("ticketing.closeRequest")}
                        svgBefore={imgClose}
                        disabled={this.props.sendingRequest}
                        onClick={this.handleCloseModalClick}
                    />
                ) : (
                    <CancelButton disabled={this.props.sendingRequest} onClick={this.handleCloseModalClick} />
                )}
                {this.props.params.ticket?.status === ticketTypes.TICKET_STATUS_ANSWERED.id &&
                this.isRequestOrClaim() &&
                this.props.params.ticket?.jsonAttributes?.formula_xml ? (
                    <Button
                        label={translate("general.loadFormula")}
                        svgBefore={imgLoad}
                        disabled={this.props.loading}
                        onClick={this.handleLoadFormulaButton}
                    />
                ) : null}
            </React.Fragment>
        );
    };

    getHeaderText = () => {
        if (!this.props.params.ticket) {
            return translate("ticketing.newTicket");
        }

        return (
            <React.Fragment>
                <div className="img-icon-btn">
                    <ReactSVG src={iconHelper.getTicketTypeIcon(this.state.type)} className="margin-right-5" />
                </div>
                {translationHelper.getTicketTypeTranslation(this.state.type)}
                {this.props.params.ticket.ticketId && <span className="text-muted">&#160;/&#160;</span>}
                {this.props.params.ticket.ticketId &&
                    translate("ticketing.ticketId") + ": " + this.props.params.ticket.ticketId}
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                className={this.state.localData ? "custom-formula" : null}
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(this.getHeaderText())}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "75%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    return {
        loggedUser: store.login.loggedUser?.login ?? "",
        customer: store.customers?.[ownProps.tabId]?.customer ?? null,
        formula: store.formula[ownProps.tabId]?.formula,
        posInfo: store.license.registrationData.pointOfSale,
        ticketList: store.ticketing.tickets,
        colorList: store.ticketing.colorList,
        fandeckList: store.ticketing.fandeckList,
        productList: store.ticketing.productList,
        baseList: store.ticketing.baseList,
        serviceDepartmentList: store.ticketing.serviceDepartmentList,
        sendingRequest: store.server.requests.some((request) => request.method === handlers.CREATE_TICKET),
        version: store.module.softwareVersion,
        loading: store.server.requests.some((request) => request.tabId === ownProps.tabId)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseCreateTicketModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.TICKETING_MODAL));
        },
        dispatchCreateTicketAction: (ticket, version) => {
            dispatch(ticketingActions.createTicket(ticket, version));
        },
        dispatchOpenCustomersModal: (tabId) => {
            dispatch(navigationActions.openModal(tabId, componentTypes.CUSTOMERS_MODAL));
        },
        dispatchSaveFileToPath: (fileId, path) => {
            dispatch(importDataActions.downloadLocalFileToPath(fileId, path));
        },
        dispatchGetFandeck: (colorId, fandeckName) => {
            dispatch(ticketingActions.getFandeckList(colorId, fandeckName));
        },
        dispatchGetColor: (fandeckId, colorName) => {
            dispatch(ticketingActions.getColorList(fandeckId, colorName));
        },
        dispatchGetProduct: (baseName, productName) => {
            dispatch(ticketingActions.getProductList(baseName, productName));
        },
        dispatchGetBase: (productId, baseName) => {
            dispatch(ticketingActions.getBaseList(productId, baseName));
        },
        dispatchAddAndLoadTicketFormula: (tabId, formulaXml, formula, ticketId) => {
            dispatch(ticketingActions.checkAndAddCustomFormulaFromXml(tabId, formulaXml, formula, ticketId));
        },
        dispatchLoadTicketFormula: (tabId, formulaId) => {
            dispatch(formulaActions.getFormulaById(tabId, formulaId));
        },
        dispatchGetServiceDepartments: () => {
            dispatch(ticketingActions.getServiceDepartments());
        }
    };
};

export default TicketingModal = connect(mapStoreToProps, mapDispatchToProps)(TicketingModal);
